import { createAsyncThunk } from '@reduxjs/toolkit';
import { TopListService } from '../../epics/lists';
import {
    topBikeKey,
    topCarKey,
    topRentKey,
    topCommercialKey,
    topDealerKey,
    topServiceKey,
    topPlacementKey,
    topCompanyKey,
    topPartsKey,
} from './listsKeys';

export const getTopBikeList = createAsyncThunk(
    topBikeKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopBikeList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopCarList = createAsyncThunk(
    topCarKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopCarList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopCommercialList = createAsyncThunk(
    topCommercialKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopCommercialList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopDealerList = createAsyncThunk(
    topDealerKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopDealerList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopServiceList = createAsyncThunk(
    topServiceKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopServiceList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopPlacementList = createAsyncThunk(
    topPlacementKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopPlacementList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopCompanyList = createAsyncThunk(
    topCompanyKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopCompanyList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopRentList = createAsyncThunk(
    topRentKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopRentList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getTopPartsList = createAsyncThunk(
    topPartsKey,
    async (_, thunkAPI) => {
        try {
            const response = await TopListService.getTopPartsList();
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);
